export const translations = {
    en: {
      // Navigation
      home: 'Home',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      faq: 'FAQ',
      
      // Language Modal
      chooseLanguage: 'Choose Your Language',
      selectLanguage: 'Select the language you prefer',
      
      // Hero Section
      heroTitle: 'Sweet Like Nina',
      heroSubtitle: 'Bespoke Cakes & Sweet Treats',
      heroDescription: 'Creating magical moments with handcrafted cakes and delicious sweet treats, made with love and attention to every detail.',
      getQuote: 'Get Quote',
      
      // Services Section
      servicesTitle: 'Our Sweet Services',
      servicesSubtitle: 'Every creation is unique, just like you',
      
      service1Title: 'Bespoke Cakes',
      service1Desc: 'Custom designed cakes for weddings, birthdays, and special occasions',
      
      service2Title: 'Sweet Treats',
      service2Desc: 'Cupcakes, cookies, macarons and other delightful sweet treats',
      
      service3Title: 'Event Catering',
      service3Desc: 'Complete dessert catering for your special events',
      
      // About Section
      aboutTitle: 'About Nina',
      aboutSubtitle: 'Passion for Sweetness',
      aboutText: 'With over 10 years of experience in baking and cake decoration, Nina creates edible masterpieces that not only look stunning but taste incredible. Every cake tells a story, and every sweet treat is made with love and dedication to perfection.',
      
      // Contact Form
      contactTitle: 'Get Your Custom Quote',
      contactSubtitle: 'Tell us about your sweet vision',
      
      formName: 'Full Name',
      formEmail: 'Email Address',
      formPhone: 'Phone Number',
      formDescription: 'Description of your order',
      formSize: 'Size/Servings',
      formReference: 'Reference Image',
      formReferencePlaceholder: 'Upload your inspiration image',
      
      submitQuote: 'Get Quote',
      
      // FAQ Section
      faqTitle: 'Frequently Asked Questions',
      
      faq1Q: 'How far in advance should I place my order?',
      faq1A: 'For custom cakes, we recommend booking at least 2-3 weeks in advance, especially for special occasions like weddings or large events.',
      
      faq2Q: 'Do you offer delivery?',
      faq2A: 'Yes, we offer delivery within a 5 miles radius of Croydon. Delivery fees apply based on distance and order size.',
      
      faq3Q: 'Can you accommodate dietary restrictions?',
      faq3A: 'Absolutely! We offer gluten-free, sugar-free, vegan, and other dietary options. Please specify your requirements when placing your order.',
      
      faq4Q: 'What is your cancellation policy?',
      faq4A: 'Orders can be cancelled up to 48 hours before delivery with a full refund. After that, a 50% charge applies due to preparation costs.',
      
      // Footer
      footerText: 'Made with love by Nina',
      followUs: 'Follow Us',
      
      // Additional useful translations
      gallery: 'Gallery',
      ourCreations: 'Our Creations',
      contactInfo: 'Contact Information',
      businessHours: 'Business Hours',
      quickLinks: 'Quick Links',
      allRightsReserved: 'All rights reserved',
      madeWithLove: 'Made with ❤️ and lots of sugar'
    },
    
    ro: {
      // Navigation
      home: 'Acasă',
      services: 'Servicii',
      about: 'Despre',
      contact: 'Contact',
      faq: 'Întrebări',
      
      // Language Modal
      chooseLanguage: 'Alegeți Limba',
      selectLanguage: 'Selectați limba pe care o preferați',
      
      // Hero Section
      heroTitle: 'Sweet Like Nina',
      heroSubtitle: 'Torturi Personalizate & Dulciuri',
      heroDescription: 'Creăm momente magice cu torturi artizanale și dulciuri delicioase, făcute cu dragoste și atenție la fiecare detaliu.',
      getQuote: 'Solicită Ofertă',
      
      // Services Section
      servicesTitle: 'Serviciile Noastre Dulci',
      servicesSubtitle: 'Fiecare creație este unică, la fel ca tine',
      
      service1Title: 'Torturi Personalizate',
      service1Desc: 'Torturi personalizate pentru nunți, zile de naștere și ocazii speciale',
      
      service2Title: 'Dulciuri',
      service2Desc: 'Cupcakes, fursecuri, macarons și alte dulciuri delicioase',
      
      service3Title: 'Catering Evenimente',
      service3Desc: 'Catering complet pentru deserturile evenimentelor voastre speciale',
      
      // About Section
      aboutTitle: 'Despre Nina',
      aboutSubtitle: 'Pasiune pentru Dulceață',
      aboutText: 'Cu peste 5 ani de experiență în cofetărie și decorarea torturilor, Nina creează capodopere comestibile care nu doar arată uimitor, ci gustă incredibil. Fiecare tort spune o poveste, iar fiecare dulciuri este făcut cu dragoste și dedicare pentru perfecțiune.',
      
      // Contact Form
      contactTitle: 'Obțineți Oferta Personalizată',
      contactSubtitle: 'Spuneți-ne despre viziunea voastră dulce',
      
      formName: 'Nume Complet',
      formEmail: 'Adresa Email',
      formPhone: 'Numărul de Telefon',
      formDescription: 'Descrierea comenzii',
      formSize: 'Mărime/Porții',
      formReference: 'Imagine de Referință',
      formReferencePlaceholder: 'Încărcați imaginea inspirației',
      
      submitQuote: 'Solicită Ofertă',
      
      // FAQ Section
      faqTitle: 'Întrebări Frecvente',
      
      faq1Q: 'Cu cât timp înainte trebuie să plasez comanda?',
      faq1A: 'Pentru torturile personalizate, recomandăm rezervarea cu cel puțin 2-3 săptămâni înainte, mai ales pentru ocazii speciale precum nunți sau evenimente mari.',
      
      faq2Q: 'Oferiți livrare?',
      faq2A: 'Da, oferim livrare într-o rază de 5 mile de Croydon. Se aplică taxe de livrare în funcție de distanță și mărimea comenzii.',
      
      faq3Q: 'Puteți acomoda restricții alimentare?',
      faq3A: 'Absolut! Oferim opțiuni fără gluten, fără zahăr, vegane și alte opțiuni dietetice. Vă rugăm să specificați cerințele când plasați comanda.',
      
      faq4Q: 'Care este politica de anulare?',
      faq4A: 'Comenzile pot fi anulate cu până la 48 de ore înainte de livrare cu rambursare completă. După aceea, se aplică o taxă de 50% din cauza costurilor de preparare.',
      
      // Footer
      footerText: 'Făcut cu dragoste de Nina',
      followUs: 'Urmăriți-ne',
      
      // Additional useful translations
      gallery: 'Galerie',
      ourCreations: 'Creațiile Noastre',
      contactInfo: 'Informații de Contact',
      businessHours: 'Program de Lucru',
      quickLinks: 'Link-uri Rapide',
      allRightsReserved: 'Toate drepturile rezervate',
      madeWithLove: 'Făcut cu ❤️ și multă dragoste'
    }
  };